import { useState, useEffect } from "react";
import Nav from "./Nav";
import Footer from "./Footer";
import "./styles/home.scss";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import IndvAsset from "./AssetManagement/IndvAsset";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Modal } from "@mui/material";
import AddAssetModal from "./AssetManagement/AddAssetModal";
import {
  getAllAssets,
  getAssetTypes,
  getAssetLocations,
} from "../utils/utilsAPI";
import Loader from "./Loader";
import QrCodeIcon from "@mui/icons-material/QrCode";
import QRCheck from "./AssetManagement/QRCheck";
import ChecklistIcon from "@mui/icons-material/Checklist";
import ListCheckout from "./AssetManagement/ListCheckout";

export default function Home() {
  //Assets
  const [assetsFixed, setAssetsFixed] = useState([]);
  const [assetsDisplayed, setAssetsDisplayed] = useState([]);
  const [assetTypes, setAssetTypes] = useState([]);
  const [assetLocations, setAssetLocations] = useState([]);
  //Search
  const [searchedAssetName, setSearchedAssetName] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  //Modals
  const [openAddAsset, setOpenAddAsset] = useState(false);
  const [openQRScan, setOpenQRScan] = useState(false);
  const [openLists, setOpenLists] = useState(false);
  //Reload & Loader
  const [reload, setReload] = useState(false);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    //Begin Loader
    setLoader(true);
    //Bring in Asset Types
    getAssetTypes()
      .then((res) => {
        setAssetTypes(res.assetTypes);
      })
      .catch((err) => {
        console.log(err);
      });
    //Bring in Locations
    getAssetLocations()
      .then((res) => {
        setAssetLocations(res.locations);
      })
      .catch((err) => {
        console.log(err);
      });

    //Bring in Assets
    getAllAssets()
      .then((res) => {
        console.log(res);
        //Set assets dependent on User role (Admin or Media)
        if (localStorage.getItem("access") != process.env.REACT_APP_ADMIN_ID) {
          let _filterdAssets = res.assets.filter((a, i) => {
            return a.assetTypeId == 28;
          });
          setAssetsDisplayed(_filterdAssets);
          setAssetsFixed(_filterdAssets);
        } else {
          setAssetsDisplayed(res.assets);
          setAssetsFixed(res.assets);
        }

        setLoader(false);
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  }, [reload]);

  const refreshAssets = () => {
    setReload(!reload);
  };

  const resetAssets = () => {
    setAssetsDisplayed(assetsFixed);
    setSearchedAssetName("");
  };

  const handleSearch = (name) => {
    setSearchedAssetName(name);
    let filteredUsers = assetsFixed.filter((asset) => {
      let _assetName = asset.assetName.toLowerCase();
      let _assetId = asset.assetId;
      let _assetTypeName = asset.assetTypeName.toLowerCase();
      let _serialNumber = asset.serialNumber.toLowerCase();
      let _userName = asset.userName ? asset.userName.toLowerCase() : "";

      return (
        _assetName.includes(name.toLowerCase()) ||
        _assetId.includes(name.toLowerCase()) ||
        _assetTypeName.includes(name.toLowerCase()) ||
        _serialNumber.includes(name.toLowerCase()) ||
        _userName.includes(name.toLowerCase())
      );
    });
    setAssetsDisplayed(filteredUsers);
  };

  return (
    <>
      <Nav />
      <main className="home">
        <h1 className="page-header">
          Asset Managment {` - ${localStorage.getItem("username")}`}
        </h1>
        <section className="home-content">
          <section className="search-section">
            <input
              type="text"
              value={searchedAssetName}
              onChange={(e) => handleSearch(e.target.value)}
              placeholder="Search by Name/Type/ID/Serial/User"
              maxLength={50}
            />
          </section>
          <section className="assets-table-container">
            <div className="header-btns">
              <Button
                color="success"
                variant="contained"
                onClick={() => setOpenQRScan(true)}
              >
                <QrCodeIcon fontSize="large" />
              </Button>
              <Button color="warning" variant="contained" onClick={resetAssets}>
                <RefreshIcon fontSize="large" />
              </Button>
              <Button
                color="info"
                variant="contained"
                onClick={() => setOpenLists(true)}
              >
                <ChecklistIcon fontSize="large" />
              </Button>
              {localStorage.getItem("access") ==
              process.env.REACT_APP_ADMIN_ID ? (
                <Button
                  variant="contained"
                  onClick={() => setOpenAddAsset(true)}
                >
                  <AddIcon fontSize="large" />
                </Button>
              ) : null}
            </div>
            {!loader ? (
              assetsDisplayed.length > 0 ? (
                <table className="assets-table">
                  <thead>
                    <tr
                      className={
                        localStorage.getItem("access") ==
                        process.env.REACT_APP_ADMIN_ID
                          ? "admin-row"
                          : ""
                      }
                    >
                      <th>ID</th>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Location</th>
                      <th>Checked by</th>
                      <th>Damages</th>
                      <th>Check In/Out</th>
                      {localStorage.getItem("access") ==
                      process.env.REACT_APP_ADMIN_ID ? (
                        <>
                          <th>Edit</th>
                          <th>Delete</th>
                          <th>Logs </th>
                        </>
                      ) : null}
                    </tr>
                  </thead>
                  <tbody>
                    {assetsDisplayed && assetsDisplayed.length > 0
                      ? assetsDisplayed.map((a, i) => {
                          return (
                            <IndvAsset
                              key={i}
                              asset={a}
                              assetTypes={assetTypes}
                              assetLocations={assetLocations}
                              refreshAssets={refreshAssets}
                            />
                          );
                        })
                      : null}
                  </tbody>
                </table>
              ) : (
                <h2>No Assets Found</h2>
              )
            ) : (
              <Loader />
            )}
          </section>
        </section>
      </main>
      <Footer />
      {/* MODALS */}
      <Modal open={openAddAsset}>
        <AddAssetModal
          assetTypes={assetTypes}
          assetLocations={assetLocations}
          handleClose={setOpenAddAsset}
          refreshAssets={refreshAssets}
        />
      </Modal>
      <Modal open={openQRScan}>
        <QRCheck
          handleClose={setOpenQRScan}
          assetLocations={assetLocations}
          refreshAssets={refreshAssets}
        />
      </Modal>
      <Modal open={openLists}>
        <ListCheckout
          handleClose={setOpenLists}
          assetLocations={assetLocations}
          refreshAssets={refreshAssets}
        />
      </Modal>
    </>
  );
}
